export default __webpack_public_path__ + "static/full-star-5fd4c9784b62a814dbd36e8b19d2004c.svg";